import { toast } from '@/components/ui/use-toast'
import { cn } from '@/lib/utils'
import { useCallback, type ReactNode } from 'react'
import { useDropzone } from 'react-dropzone'
import {
  CPT_IMAGE_ACCEPT,
  useBatchUploadDropStore,
} from '../BatchUpload/dropStore'

type CptListDropZoneProps = {
  children: ReactNode
  className?: string
}

export const CptListDropZone = ({
  children,
  className,
}: CptListDropZoneProps) => {
  const openWithFiles = useBatchUploadDropStore((s) => s.openWithFiles)

  const onDrop = useCallback(
    (acceptedFiles: File[]) => {
      if (acceptedFiles.length === 0) {
        toast({
          variant: 'destructive',
          title: '未识别到图片',
          description: '请拖拽 jpg / png / jpeg / webp 文件',
        })
        return
      }
      openWithFiles(acceptedFiles)
    },
    [openWithFiles],
  )

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: CPT_IMAGE_ACCEPT,
    multiple: true,
    noClick: true,
    noKeyboard: true,
  })

  return (
    <div
      {...getRootProps()}
      className={cn('relative min-h-0', className)}
    >
      <input {...getInputProps()} className="hidden" />
      {children}
      {isDragActive ? (
        <div className="pointer-events-none absolute inset-0 z-20 rounded-md border-2 border-dashed border-primary bg-primary/10">
          <div className="sticky top-16 flex justify-center pt-8">
            <span className="rounded-md bg-background/90 px-3 py-1.5 text-sm font-medium text-primary shadow-sm">
              松开以上传组件
            </span>
          </div>
        </div>
      ) : null}
    </div>
  )
}
